import { Component, Inject, Input } from '@angular/core';
import { Reservation } from '../../api/model/reservation/reservation.model';
import { SiteURLUtils } from '../../common/site.url.utils';
import { redirectToURL } from '../../common/common';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../../api/config';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { ReservationService } from '../../api/services/reservation.service';

@Component({
  selector: 'modify-rate',
  templateUrl: './modify-rate.component.html',
  styleUrls: ['./modify-rate.component.scss']
})
export class ModifyRateComponent {
  _reservation: Reservation;
  showRateDetails: boolean;
  hasGroupCode: boolean;
  isContinueMode = false;
  reservationService: ReservationService;
  @Input() isOpen: boolean;
  @Input() messages;
  @Input() set reservation(reservation: Reservation) {
    this._reservation = reservation;
    this.isContinueMode = false;
    this.hasGroupCode = !!this._reservation.rate.groupCode;
  }
  @Input() hotel: Hotel;

  get reservation(): Reservation {
    return this._reservation;
  }

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) { }

  switchDetails(flag: boolean) {
    this.showRateDetails = flag;
  }

  change() {
    if (this.isContinueMode) {
      redirectToURL(SiteURLUtils.getLocalizedChangeRoomUrl(this.appConfig, this._reservation, this.hotel, true));
    } else {
      this.isContinueMode = true;
    }
  }

  redirectToRatePage() {
    if (this.hasGroupCode) {
      this.change();
    } else {
      redirectToURL(SiteURLUtils.getLocalizedChangeRateUrl(this.appConfig, this._reservation, this.hotel));
    };
  }

  cancel() {
    this.isContinueMode = false;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/modify-rate/modify-rate.component.ts